import { ReactElement } from 'react';
import { GenericFields } from './GenericFields';
import { CreativeFields } from './CreativeFields';
import { FieldsProps } from './types';

export function BriefFields(props: FieldsProps): ReactElement {
  return props.type === 'CREATIVE' ? <CreativeFields {...props} /> : <GenericFields {...props} />;
}
